export function paramsFromSchema(schema = [], overrides = {}) {
  const out = {};
  for (const field of schema) {
    if (!field?.key) continue;
    const next = overrides[field.key];
    out[field.key] = next === undefined || next === null || next === '' ? field.default : next;
    if (field.type === 'number') {
      const n = Number(out[field.key]);
      out[field.key] = Number.isFinite(n) ? n : field.default;
    }
    if (field.type === 'time') {
      const s = String(out[field.key] ?? '').trim();
      out[field.key] = s || field.default;
    }
  }
  return out;
}

export function schemaDefaults(schema = []) {
  return paramsFromSchema(schema, {});
}
